import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

class PaginationComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.pageChange = new EventEmitter();
        this.buttons = [];
    }
    pageChanged(p) {
        this.page = p;
        this.pageChange.emit(this.page);
    }
    prevDisabled() {
        return this.page <= 1 ? 'mixitup-control-disabled' : '';
    }
    nextDisabled() {
        return this.page >= this.pages ? 'mixitup-control-disabled' : '';
    }
    buttonDisabled(x) {
        return x === this.page ? 'mixitup-control-active' : '';
    }
    ngOnInit() {
        this.leftArrow = this.sanitizer.bypassSecurityTrustHtml(leftArrow());
        this.rightArrow = this.sanitizer.bypassSecurityTrustHtml(rightArrow());
        this.ResetPages();
    }
    ngOnChanges() {
        this.ResetPages();
    }
    ResetPages() {
        this.buttons = this.Buttons(this.page, this.pages);
    }
    Buttons(page, pages) {
        const numbers = [];
        const buttons = 7;
        const half = Math.floor(buttons / 2.0);
        if (pages <= buttons) {
            for (let i = 1; i <= pages; i++) {
                numbers.push(i);
            }
        }
        else if (page <= half) {
            for (let j = 1; j < buttons; j++) {
                numbers.push(j);
            }
            numbers.push('ellipsis');
            numbers.push(pages);
        }
        else if (page >= pages - half) {
            for (let k = pages + 1 - (buttons - 1); k <= pages; k++) {
                numbers.push(k);
            }
            numbers.unshift('ellipsis');
            numbers.unshift(1);
        }
        else {
            for (let m = page - 2; m <= page + 2; m++) {
                numbers.push(m);
            }
            numbers.push('ellipsis');
            numbers.push(pages);
            numbers.unshift('ellipsis');
            numbers.unshift(1);
        }
        numbers.unshift('previous');
        numbers.push('next');
        return numbers;
    }
}
PaginationComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-pagination',
                template: "<div class=\"mixitup-page-list\">\r\n    <ng-container *ngFor=\"let x of buttons\">\r\n      <ng-container [ngSwitch]=\"x\">\r\n        <a *ngSwitchCase=\"'ellipsis'\" class=\"no-loader\">&hellip;</a>\r\n        <a *ngSwitchCase=\"'previous'\" class=\"no-loader mixitup-control mixitup-control-prev {{ prevDisabled() }}\" (click)=\"pageChanged(page - 1)\">\r\n            <span [innerHTML]=\"leftArrow\"></span>\r\n            <p>Previous</p> \r\n        </a>\r\n        <a *ngSwitchCase=\"'next'\" class=\"no-loader mixitup-control mixitup-control-next {{ nextDisabled() }}\" (click)=\"pageChanged(page + 1)\">            \r\n            <p>Next</p>\r\n            <span [innerHTML]=\"rightArrow\"></span>\r\n        </a>\r\n        <a *ngSwitchDefault class=\"no-loader mixitup-control {{ buttonDisabled(x) }}\" (click)=\"pageChanged(x)\">&nbsp;{{x}}&nbsp;</a>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>"
            },] }
];
PaginationComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
PaginationComponent.propDecorators = {
    page: [{ type: Input }],
    pages: [{ type: Input }],
    pageChange: [{ type: Output }]
};

class PaginationModule {
}
PaginationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [PaginationComponent],
                imports: [CommonModule, FormsModule],
                exports: [PaginationComponent],
            },] }
];

/*
 * Public API Surface of pagination
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PaginationComponent, PaginationModule };
//# sourceMappingURL=pagination.js.map
